import { all, takeLatest } from 'redux-saga/effects';
import { signIn } from './auth/sagas';
import { LoginTypes } from './auth/types';
import { CategoryTypes } from './category/types';
import { getCategory } from './category/sagas';
import { LocalclassificationTypes } from './localClassification/types';
import { getLocalClassifications } from './localClassification/sagas';
import {
  getLocais, createLocal, getLocalById, updateLocal,
} from './locais/sagas';
import { LocalTypes } from './locais/types';

export default function* rootSaga(): any {
  return yield all([
    // @ts-ignore
    takeLatest(LoginTypes.SIGN_IN_REQUEST, signIn),
    takeLatest(CategoryTypes.CATEGORY_REQUEST, getCategory),
    takeLatest(LocalclassificationTypes.LOCAL_CLASSIFICATION_REQUEST, getLocalClassifications),
    // @ts-ignore
    takeLatest(LocalTypes.LOCAIS_REQUEST, getLocais),
    takeLatest(LocalTypes.CREATE_LOCAL, createLocal),
    takeLatest(LocalTypes.LOCAL_REQUEST_BY_ID, getLocalById),
    takeLatest(LocalTypes.UPDATE_LOCAL, updateLocal),
  ]);
}
